// BankMeter
export const UPDATE_DEVICEID = 'UPDATE_DEVICEID';
export const UPDATE_NAVCURIDX = 'UPDATE_NAVCURIDX';
export const UPDATE_METER = 'UPDATE_METER';

